// SBR cart drawer integration
// -----------------------------------------------------------------------------
// The custom book product add-to-cart (sections/sbr-book-product.liquid) adds the
// item via cart/add.js and then dispatches a custom `cart:item-added` event, but it
// does NOT notify Horizon's cart drawer. As a result the drawer neither auto-opens
// nor refreshes its contents until a full page reload.
//
// This bridge listens for that existing `cart:item-added` event and re-dispatches it
// as Horizon's CartAddEvent (event name `cart:update`). That single event:
//   1. makes <cart-drawer-component> auto-open (it has the `auto-open` attribute), and
//   2. makes <cart-items-component> refresh — when the event carries no section HTML
//      it falls back to sectionRenderer.renderSection() (see component-cart-items.js).
//
// No protected files are modified; we only hook the event the product section already emits.
import { CartAddEvent } from '@theme/events';

document.addEventListener('cart:item-added', async (event) => {
  let cart;
  try {
    const response = await fetch(`${window.Shopify.routes.root}cart.js`);
    if (response.ok) cart = await response.json();
  } catch (e) {
    cart = undefined;
  }

  document.dispatchEvent(
    new CartAddEvent(cart, 'sbr-book-product', {
      source: 'sbr-book-product',
      variantId: event.detail?.variantId,
      itemCount: cart?.item_count,
    })
  );
});
